import React, { useContext, useMemo, useRef } from 'react';
import { Tooltip, svgSprite } from '../../../../hybrid/wrappers';
import { navigateV2 } from '../../../../common/utils/router';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
// import AppButtons from '../../../../widgets/appButtons/AppButtonsDesktop/AppButtonsDesktop';
// import RegionAndCurrencySwitcher from '../../../../widgets/regionAndCurrencySwitcher/RegionAndCurrencySwitcher/RegionAndCurrencySwitcher';
import Skeleton from '../../../../widgets/plug/Skeleton/Skeleton';
import { useRouter } from 'next/router';
import css from './office-header.module.scss';
import classNames from 'classnames';
// import NotificationsHeader from '../../../../widgets/notifications/Notifications/Notifications';
// import NotificationsQuick from '../../../../widgets/notifications/NotificationsQuick/NotificationsQuick';
// import { UseQuickNotifications } from '../../../../common/utils/UseQuickNotifications';
import { UserProfileContext, WarehouseContext } from '../../../../common/utils/getContext';
import T from '../../../../common/components/T';
import Image from 'next/image';
import HeaderMenu from '../../../../widgets/headerMenu/HeaderMenu';

const OfficeHeader = ({ toggleMenu, mainMenu, toggleWidget, widget, showSidebar, headerRightButtons, customHeader }) => {
    const { roles, profileData } = useContext(UserProfileContext);
    const { warehouse } = useContext(WarehouseContext);

    const profileRef = useRef();

    const isAdmin = useMemo(
        () => roles && roles?.length && roles?.find((role) => ['superadmin', 'admin']?.includes(role?.name)),
        [roles]
    );

    // const [qrbuttonDesctop, setQrbuttonDesctop] = useState(true);
    const router = useRouter();
    const windowDimensions = useWindowDimensions();
    const isMobile = windowDimensions < 768;
    // useEffect(() => {
    //     if (windowDimensions < 768) {
    //         setQrbuttonDesctop(false);
    //     } else {
    //         setQrbuttonDesctop(true);
    //     }
    // }, [windowDimensions]);
    const Logo = () => (
        <>
            {svgSprite('company-logo', {
                className: classNames(css.headerLogo, css.officeLogoSvg)
            })}
        </>
    );

    // const { quickNotifications, quickNotificationsForCounter, setQuickNotificationsForCounter } = UseQuickNotifications();

    // const [initNotifications, setInitNotifications] = useState(null);

    // useEffect(() => {
    //     (async () => {
    //         const data = await getData('/api/v1/user/notification/history?filter[provider]=broadcast', userToken, lang);
    //         setInitNotifications(data);
    //     })();
    // }, [lang, userToken]);

    return (
        <header className={css.officeHeader}>
            <div className={css.officeLogoWrapper}>
                {windowDimensions > 767 ? (
                    <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => navigateV2('/')}>
                        <Skeleton
                            wrapperStyles={{ width: '5rem' }}
                            elements={[{ type: 'circle', diameter: 3.5, gap: 0 }]}
                            wait={!router.isFallback}
                            Component={Logo}
                        />
                    </div>
                ) : null}
                {customHeader && customHeader.func ? (
                    <div className={css.cusetomHeaderArrow} onClick={() => customHeader.func()}>
                        {svgSprite('arrow-left', { width: 16, height: 11 })}
                    </div>
                ) : (
                    <div
                        className={css.officeBurger}
                        onClick={() => {
                            toggleMenu();
                            widget && toggleWidget();
                        }}
                    >
                        <div className={css.officeBurgerLine} />
                        <div className={css.officeBurgerLine} />
                        <div
                            className={classNames(css.officeBurgerLine, {
                                [css.officeBurgerLineActive]: mainMenu
                            })}
                        />
                    </div>
                )}
            </div>
            {/* <div style={{ flex: 1, alignItems: 'center' }}>
                <p className={classNames(css.pageTitle, showSidebar && !customHeader?.hideUserButton ? css.pageTitlePL : '')}>
                    {customHeader?.title || title}
                </p>
            </div> */}
            {/* {qrbuttonDesctop && <AppButtons />} */}
            {windowDimensions < 768 &&
                Object.keys(headerRightButtons).map((button) => (
                    <div key={button} onClick={headerRightButtons[button].func} className={css.headerRightButton}>
                        {svgSprite(headerRightButtons[button].icon, {
                            className: css.headerRightButtonSvg
                        })}
                    </div>
                ))}
            {showSidebar && !customHeader?.hideUserButton ? (
                <div className={classNames(css.widgetsButtonWrap, css.widgetsButtonWrapMob)}>
                    <div className={css.widgetsButtonMob} onClick={() => toggleWidget()}>
                        {svgSprite('user-circle', {
                            className: css.widgetsButtonSvgMobile,
                            fill: 'var(--greyExtraDarkColor)'
                        })}
                    </div>
                </div>
            ) : null}
            <HeaderMenu />
            <div className={css.headerButtonsWrapper}>
                {!!isAdmin ? (
                    <Tooltip showModalTooltip={!isMobile} text={<T textName='admin_panel' defaultStr='Админ панель' />}>
                        <div onClick={() => navigateV2('/admin')} className={css.headerButton}>
                            {svgSprite('gear-gt', { className: css.headerButtonSvg })}
                        </div>
                    </Tooltip>
                ) : null}
                {warehouse ? (
                    <Tooltip showModalTooltip={!isMobile} text={<T textName='stock' defaultStr='Склад' />}>
                        <div
                            onClick={() => {
                                navigateV2('/warehouse');
                            }}
                            className={css.headerButton}
                        >
                            {svgSprite('stock', { className: css.headerButtonSvg })}
                        </div>
                    </Tooltip>
                ) : null}
                <Tooltip showModalTooltip={!isMobile} text={<T textName='store' defaultStr='Магазин' />}>
                    <div onClick={() => navigateV2('/store')} className={css.headerButton}>
                        {svgSprite('cart-new', { className: css.headerButtonSvg })}
                    </div>
                </Tooltip>
                <Tooltip showModalTooltip={!isMobile} text={<T textName='profile' defaultStr='Профиль' />}>
                    <div
                        ref={profileRef}
                        onClick={() => navigateV2('/profile')}
                        className={classNames(css.headerButton, css.headerButtonUserImage)}
                    >
                        {profileData?.image?.links?.preview ? (
                            <Image
                                className={css.profileImg}
                                alt='User image'
                                width={40}
                                height={40}
                                src={profileData?.image?.links?.preview}
                                quality={100}
                            />
                        ) : (
                            <div style={{ display: 'flex' }}>
                                {svgSprite('plug-user-image', { className: css.profileImgSvg })}
                            </div>
                        )}
                    </div>
                </Tooltip>
            </div>
            {/* <div>{windowDimensions > 767 && <RegionAndCurrencySwitcher />}</div> */}

            {/* <NotificationsHeader
                quickNotificationsForCounter={quickNotificationsForCounter}
                setQuickNotificationsForCounter={setQuickNotificationsForCounter}
                quickNotifications={quickNotifications}
                initNotifications={initNotifications}
            />

            <div className={css.notificationsQuickWrapper}>
                {quickNotifications.map((el) => (
                    <NotificationsQuick key={el?.id} notification={el} />
                ))}
            </div> */}
            {/* {refPortal ? <RefPortal closeHandler={() => showRefPortal(false)} elem={profileRef} /> : null} */}
        </header>
    );
};

export default OfficeHeader;
